import React from "react";
import ConfirmDialog from "./ConfirmDialog";
import MeritoButton from "./MeritoButtons/MeritoButtons";
import styles from "./MeritoActionPopup.module.scss";

export interface MeritoActionPopupProps {
  visible: boolean;
  title: string;
  firstStatement: string;
  secondStatement: string;
  secondaryButtonText: string;
  primaryButtonText: string;
  primaryLoading?: boolean;
  onSecondary: () => void | Promise<void>;
  onPrimary: () => void | Promise<void>;
  onDismiss: () => void;
}

const MODAL_STYLES = {
  width: "calc(100vw - 2rem)",
  maxWidth: "28.125rem",
};

const MeritoActionPopup = ({
  visible,
  title,
  firstStatement,
  secondStatement,
  secondaryButtonText,
  primaryButtonText,
  primaryLoading = false,
  onSecondary,
  onPrimary,
  onDismiss,
}: MeritoActionPopupProps) => (
  <ConfirmDialog
    visible={visible}
    toggle={primaryLoading ? () => undefined : onDismiss}
    showButton={false}
    showCloseBtn={false}
    backdrop="static"
    modalStyles={MODAL_STYLES}
    modalClassName={styles.modal}
    contentClassName={styles.content}
    bodyClassName={styles.body}
    size="md"
  >
    <div className={styles.popup}>
      <div className={styles.copy}>
        <h2>{title}</h2>
        <div className={styles.statements}>
          <p>{firstStatement}</p>
          <p>{secondStatement}</p>
        </div>
      </div>
      <div className={styles.actions}>
        <MeritoButton
          type="tertiary"
          size="lg"
          isRounded
          hover={false}
          disabled={primaryLoading}
          className={styles.secondaryAction}
          btnText={secondaryButtonText}
          onClick={onSecondary}
        />
        <MeritoButton
          type="primary-1"
          size="lg"
          isRounded
          loading={primaryLoading}
          disabled={primaryLoading}
          className={styles.primaryAction}
          btnText={primaryButtonText}
          onClick={onPrimary}
        />
      </div>
    </div>
  </ConfirmDialog>
);

export default MeritoActionPopup;
